import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditIcon from '@material-ui/icons/Edit';
import Pagination from '@material-ui/lab/Pagination';
import isEmpty from 'lodash/isEmpty';
import WgChip from 'pages/WellGuardian/WgChip';
import { WIRUser } from 'types/wellGuardian';

import styles from './UserDetailsModalTable.module.scss';
import { getUserRole } from '../../utils';

type HeadCell = {
  id: string;
  label: string | null;
};

type UserDetailsModalTableProps = {
  wirUsersForPage: WIRUser[];
  allWirUsers: WIRUser[];
  pageSize: number;
  page: number;
  handlePageChange: (_event: React.ChangeEvent<unknown>, value: number) => void;
  handleUserEditSelect: (item: any) => void;
  handleUserDeleteSelect: (item: any) => void;
};

const ALL_WIR = 'ALL';

const headCells: HeadCell[] = [
  { id: 'userId', label: 'User ID' },
  { id: 'userName', label: 'Name' },
  { id: 'emailAddress', label: 'Email' },
  { id: 'country', label: 'Country' },
  { id: 'assets', label: 'Asset' },
  { id: 'roles', label: 'Role' },
  { id: 'edit', label: null },
  { id: 'delete', label: null },
];

const UserDetailsModalTable: React.FunctionComponent<UserDetailsModalTableProps> = ({
  wirUsersForPage,
  allWirUsers,
  pageSize,
  page,
  handlePageChange,
  handleUserEditSelect,
  handleUserDeleteSelect,
}) => {
  return (
    <>
      <TableContainer className={styles.tableContainer} data-testid="user-detail-table-modal">
        <Table>
          <TableHead>
            <TableRow className={styles.tableHeaderRow}>
              {headCells.map(headCell => (
                <TableCell key={headCell.id} align="left" className={styles.tableHeadCell}>
                  {headCell.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {wirUsersForPage?.map(item => (
              <TableRow key={item.userId} className={styles.tableBodyRow}>
                <TableCell className={styles.tableBodyCell}>
                  <WgChip
                    config={{
                      text: item.userId,
                      className: styles.grayTag,
                    }}
                  />
                </TableCell>
                <TableCell className={styles.tableBodyCell}>{item.userName}</TableCell>
                <TableCell className={styles.tableBodyCell}>{item.emailAddress}</TableCell>
                <TableCell className={styles.tableBodyCell}>
                  {item.country?.toUpperCase()}
                </TableCell>
                <TableCell className={styles.tableBodyCell}>
                  {item?.assets.indexOf(ALL_WIR) === -1 ? item?.assets?.join(', ') : ALL_WIR}
                </TableCell>
                <TableCell className={styles.tableBodyCell}>{getUserRole(item.roles)}</TableCell>
                <TableCell className={styles.tableActionBodyCell}>
                  <EditIcon
                    className={styles.editIcon}
                    onClick={() => handleUserEditSelect(item)}
                    data-testid="edit-icon"
                  />
                </TableCell>
                <TableCell className={styles.tableActionBodyCell}>
                  <DeleteOutlineIcon
                    className={styles.deleteIcon}
                    onClick={() => handleUserDeleteSelect(item)}
                    data-testid="delete-icon"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {!isEmpty(allWirUsers) && (
        <div className={styles.pagination}>
          <Pagination
            classes={{ root: styles.paginationRoot }}
            count={pageSize}
            page={page}
            onChange={handlePageChange}
          />
        </div>
      )}
    </>
  );
};

export default UserDetailsModalTable;
